<template>
  <a-drawer
    title="服务记录"
    placement="right"
    v-model:visible="serviceVisit"
    @close="onClose"
    width="458px"
    class="service_record_drawer"
  >
    <a-spin class="spinning" :spinning="loading">
      <div class="container" ref="recordRef">
        <div class="record_list" v-for="(item, index) in listData" :key="index">
          <div class="left">
            <div class="date">{{ getYearAndMonth(item.createdAt) }}</div>
            <div class="month">{{ getDay(item.createdAt) }}</div>
          </div>
          <div class="right">
            <div
              class="content"
              v-for="it in item.operationLogVOList"
              :key="it.id"
              @click="goDetails(it)"
            >
              <div class="info z-flex">
                <span class="title">{{ it.logTypeDes }}</span>
                <span class="time">{{ getHourAndMinute(it.createdAt) }}</span>
              </div>
              <div class="details z-flex">
                <!-- 工单类的只展示工单状态 -->
                <template v-if="it.operationTypeStatus">
                  <div>{{ it.operationTypeMap }}</div>
                </template>
                <template v-else>
                  <div>
                    {{ it.operationTypeMap }}
                    <span
                      class="soler"
                      :class="['patient', 'doctor', 'bd', 'assistant'][it.uploaderType - 1]"
                    >
                      {{ uploaderTypeMap[it.uploaderType - 1] }}
                    </span>
                    <span class="man">{{ it.createdName }}</span>
                  </div>
                </template>

                <span class="txt" v-if="showDetailType.includes(it.logType)">查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </a-drawer>
  <TheDetail
    v-model:visible="detailModal.visible"
    :recordType="detailModal.recordType"
    :id="detailModal.recordId"
    :serialNumber="detailModal.serialNumber"
  />
  <!-- 量表详情 -->
  <Gauge ref="gDetail" :params="detailQuery" />
  <!-- 检查单详情 -->
  <a-modal
    v-model:visible="chekcParams.visible"
    :width="1059"
    title="检查单详情"
    :bodyStyle="{
      padding: '16px 24px 18px 24px'
    }"
    :footer="null"
  >
    <checklistDetail
      :checklistId="chekcParams.checklistId"
      :visible="chekcParams.visible"
      :mode="chekcParams.mode"
      :details="chekcParams.details"
    ></checklistDetail>
  </a-modal>
  <!-- 沟通小姐详情 -->
  <a-modal
    title="沟通小结"
    v-model:visible="summaryParams.visible"
    @cancel="summaryParams.visible = false"
    width="1059px"
    :footer="null"
    :destroyOnClose="true"
    :maskClosable="false"
    :bodyStyle="{
      padding: 0,
      paddingTop: '20px'
    }"
  >
    <summaryPannel
      :chatSummaryId="summaryParams.chatSummaryId"
      @closeSummaryModal="closeSummaryModal"
    />
  </a-modal>
  <!-- 复诊预约详情 -->
  <ADetail ref="aDetail" :recordId="appointId" />
  <!-- 问卷结果iframe -->
  <Info ref="infoRef" :url="scaleResultsUrl"></Info>
</template>
<script setup>
import { defineProps, ref, watch, defineEmits, nextTick, computed, reactive } from 'vue'
import { getServiceLog } from '@/api/chat'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getHourAndMinute, getYearAndMonth, getDay } from '@/utils'
import TheDetail from '@/components/TheDetail'
import Gauge from '@/views/WorkPlace/Container/Gauge/components/gDetail.vue'
import checklistDetail from '@/views/HealthRecord/checklistDetail.vue'
import { subStringToType } from '@/utils/index'
import summaryPannel from '@/views/WorkPlace/Container/chat/components/summaryPannel/index.vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import Info from '@/views/WorkPlace/Container/chat/components/ScaleResults/Info.vue'
import { message } from 'ant-design-vue'
const props = defineProps({
  serviceRecordVisible: {
    type: Boolean,
    default: false,
    required: true
  }
})
const emits = defineEmits(['onClose'])
const store = useStore()
const router = useRouter()
const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const ucPatientId = curGroupInfo.value.patientInfo.ucUserId
const ucDoctorId = curGroupInfo.value.doctorInfo.ucUserId
const serviceVisit = ref(false)
const loading = ref(false)
const recordRef = ref(null)
const infoRef = ref(null)
const listData = ref([])
const scaleResultsUrl = ref('')
const initParams = {
  pageNo: 1,
  pageSize: 10,
  hasNext: false
}
let params = { ...initParams }
const uploaderTypeMap = ['患者', '医生', 'BD', '健管', '医生学生'] //操作人角色 1-患者 2-医生 3-bd 4-医生助手
watch(
  () => props.serviceRecordVisible,
  val => {
    serviceVisit.value = val
    if (val) {
      params = Object.assign({}, initParams)
      listData.value = []
      getData()
      nextTick(() => {
        recordRef.value.addEventListener('scroll', handleScroll)
      })
    } else {
      recordRef.value.removeEventListener('scroll', handleScroll)
    }
  }
)
function onClose() {
  emits('onClose')
}
// // 查询数据
function getData() {
  loading.value = true
  const query = {
    ucPatientId,
    ucDoctorId,
    pageNo: params.pageNo,
    pageSize: params.pageSize
  }
  getServiceLog(query)
    .then(data => {
      const { list = [], currPage, hasNext = false } = data
      listData.value = listData.value.concat(list)
      params.pageNo = currPage + 1
      params.hasNext = hasNext
    })
    .catch(() => {
      listData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
const showDetailType = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11]
// 查看详情  1, 健康信息 2, 线上病历 3, 门诊病历 4, 西药处方 5, 中药处方 6, 健康辅助方 7, 随访量表 8, 检查表单 9, 沟通小结 11 复诊预约
function goDetails(item) {
  const { logType, businessId, snapshot = {} } = item
  const serialNumber = snapshot?.serialNumber || ''
  let type = ''
  switch (logType) {
    case 1:
      goHealthInfo()
      break
    case 2:
    case 3:
      type = logType == 2 ? 'onLineRecord' : 'offLineRecord'
      showRecordDetails(type, businessId)
      break
    case 4:
    case 5:
    case 6:
      if (!serialNumber) return
      type = subStringToType(serialNumber)
      showPreciDetails(type, item)
      break
    case 7:
      goGaugeDetail(item)
      break
    case 8:
      goCheckDetail(item)
      break
    case 9:
      goSummaryDetail(item)
      break
    case 11:
      goAppoitDetail(item)
      break
  }
}

// 健康信息
function goHealthInfo() {
  router.push({
    path: '/healthInfo',
    query: {
      ucPatientId,
      ucDoctorId
    }
  })
}
// 病历和处方详情
const detailModal = reactive({
  visible: false,
  recordType: '',
  recordId: '',
  serialNumber: ''
})
function showRecordDetails(type, businessId) {
  detailModal.recordType = type
  detailModal.visible = true
  detailModal.recordId = businessId
}
function showPreciDetails(type, obj) {
  const { businessId = '', serialNumber = '' } = obj
  detailModal.recordType = type
  detailModal.visible = true
  detailModal.recordId = businessId
  detailModal.serialNumber = serialNumber
}
const gDetail = ref(null)
const detailQuery = reactive({
  surveySendId: null
})
// 量表详情
function goGaugeDetail(item) {
  const { businessId, content, snapshot = {} } = item
  if (snapshot?.businessType && snapshot?.businessType !== 1) {
    if (!content) return message.warning('当前量表暂不支持查看！')
    scaleResultsUrl.value = `${content}&surveyType=${snapshot?.businessType}`
    return infoRef.value.showDrawer()
  }
  gDetail.value.gDetailVisible = true
  detailQuery.surveySendId = businessId
}
const chekcParams = reactive({
  visible: false,
  checklistId: '',
  details: {},
  mode: 'snapshot'
})
// 检查单详情
function goCheckDetail(item) {
  chekcParams.visible = true
  chekcParams.checklistId = item.businessId
  chekcParams.details = item.snapshot
}
const summaryParams = reactive({
  visible: false,
  chatSummaryId: ''
})
// 沟通小节详情
function goSummaryDetail(item) {
  summaryParams.visible = true
  summaryParams.chatSummaryId = item.businessId
}
function closeSummaryModal() {
  summaryParams.visible = false
  onClose()
}
// 去复诊预约详情
const aDetail = ref(null)
const appointId = ref('')
function goAppoitDetail(item) {
  appointId.value = item.businessId
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}
// 监听页面滚动事件
function handleScroll({ target }) {
  const DOM = target
  const scrollHeight = DOM.scrollHeight, //滚动条的高度
    scrollTop = DOM.scrollTop, //滚动条在Y轴滚动过的高度
    clientHeight = DOM.clientHeight //浏览器的可视高度
  if (scrollHeight - scrollTop - clientHeight < 1 && params.hasNext) {
    getData()
  }
}
</script>
<style scoped lang="scss">
%time {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}
.container {
  height: calc(100vh - 103px);
  overflow: scroll;
}
.record_list {
  display: flex;
  margin-bottom: 16px;
  .left {
    width: 75px;
    position: relative;
    &::before {
      content: '';
      width: 1px;
      top: 48px;
      left: 0;
      bottom: 0;
      background: #d8d8d8;
      position: absolute;
    }
    .date {
      @extend %time;
    }
    .month {
      font-weight: 600;
      font-size: 18px;
      color: #333333;
    }
  }
  .right {
    flex: 1;
    .content {
      cursor: pointer;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }

      padding: 8px 12px;
      background: #f8f8f8;
      border-radius: 4px;
      .info {
        .title {
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          position: relative;
          &::before {
            content: '';
            position: absolute;
            width: 4px;
            height: 12px;
            background: #1890ff;
            left: -12px;
            top: 6px;
          }
        }
        .time {
          @extend %time;
        }
      }
      .details {
        div {
          font-weight: 500;
          font-size: 14px;
          color: #666666;
          .soler {
            font-weight: 400;
            font-size: 12px;
            padding: 4px 6px;
            border-radius: 4px;
            margin-right: 10px;
            &.patient {
              color: #ffa940;
              background-color: #ffeed9;
            }
            &.doctor {
              color: #1890ff;
              background: #e6f7ff;
            }
            &.bd {
              color: #722ed1;
              background: #f9f0ff;
            }
            &.assistant {
              color: #722ed1;
              background: #f9f0ff;
            }
          }
          .man {
            font-weight: 500;
            font-size: 14px;
            color: #666666;
          }
        }
        .txt {
          font-weight: 400;
          font-size: 14px;
          color: #1890ff;
        }
      }
    }
  }
}
</style>
